import script from "./AddUserModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddUserModal.vue?vue&type=script&setup=true&lang=js"

import "./AddUserModal.vue?vue&type=style&index=0&id=38da8e5d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38da8e5d"]])

export default __exports__